import { hotjar } from "react-hotjar";
import { HostEnvironments } from "../config/env";

const HOTJAR_ID_BY_ENV: Record<string, number> = {
  [HostEnvironments.PROD]: 3010600,
  [HostEnvironments.BETA]: 3010600,
};

export const initializeHotjar = (): void => {
  if (Object.values(HostEnvironments).includes(window.location.host)) {
    hotjar.initialize(HOTJAR_ID_BY_ENV[window.location.host], 6);
  }
};
